(function(app) {

    app.filter("splitCapitalLetter",
        function() {
            return function (str) {
                return str.replace(/([A-Z])/g, " $1").trim();
            };
        });

})(window.app); //jshint ignore:line